/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Empty_Fuzzy_Grizzly_BendInputs */

const fr_empty_fuzzy_grizzly_bend = /** @type {(inputs: Empty_Fuzzy_Grizzly_BendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cet utilisateur ne suit aucun programme`)
};

/**

* @param {Empty_Fuzzy_Grizzly_BendInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const empty_fuzzy_grizzly_bend = /** @type {((inputs?: Empty_Fuzzy_Grizzly_BendInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Empty_Fuzzy_Grizzly_BendInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_empty_fuzzy_grizzly_bend(inputs)
});